import { ActionContext, ActionTree } from "vuex";
import {
  IPracticeState,
  IPracticeSubject,
} from "@/store/modules/practice/types";
import { IAnswer, RootState } from "@/store/types";
import { ApiCaller } from "@/ApiCaller";

type PracticeActionContext = ActionContext<IPracticeState, RootState>;
type PracticeActionTree = ActionTree<IPracticeState, RootState>;

export const actions: PracticeActionTree = {
  async takeSection(
    context: PracticeActionContext,
    subject: string
  ): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      `/practice/section/${subject}`
    );
    context.commit("setSection", content.data);
  },

  async fetchContentQuestions(
    context: PracticeActionContext,
    section_id: number
  ): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      `/practice/question/${section_id}`
    );
    context.commit("setQuestions", content.data);
  },

  async fetchContentPassages(
    context: PracticeActionContext,
    section_id: number
  ): Promise<any> {
    const content = await ApiCaller.getInstance().get(
      `/practice/passages/${section_id}`
    );
    context.commit("setPassages", content.data);
  },

  async finishSection(
    context: PracticeActionContext,
    payload: {
      subject: string;
      usectionId: number;
      timeRemain: number;
      answers: any;
      completedSections: {};
    }
  ): Promise<any> {
    await context.dispatch("saveCompletedSections", payload.completedSections);
  },

  async saveCompletedSections(
    context: PracticeActionContext,
    completedSections: {}
  ): Promise<any> {
    context.commit("setCompletedSections", completedSections);
  },
};
